module.exports = __webpack_public_path__ + "static/img/6.4725b188.jpg";